import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../app/api";

export const getAppUsers = createAsyncThunk("users/getAppUsers", async (payload, { rejectWithValue }) => {
  try {
    const { data } = await api.post(`/serviceapi/appUsers`, payload);
    if (data) return data.sort((a, b) => a.name.localeCompare(b.name));
    return data;
  } catch (error) {
    if (error.response && error.response.data.message) {
      return rejectWithValue(error.response.data.message);
    } else {
      return rejectWithValue(error.message);
    }
  }
});

export const createUser = createAsyncThunk("users/createUser", async (payload, { rejectWithValue }) => {
  try {
    const response = await api.post(`/serviceapi/createUser`, payload);
    return response;
  } catch (error) {
    if (error.response && error.response.data.message) {
      return rejectWithValue(error.response.data.message);
    } else {
      return rejectWithValue(error.message);
    }
  }
});
export const getCoordinates = createAsyncThunk(
  "users/getCoordinates",
  async (address, { rejectWithValue }) => {
    const apiKey = "AIzaSyCXW0NqnwGkqOnrkrSHqv5bxMjtRqhA76o"; // Replace with your actual API key
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;

    try {
      const response = await axios.get(url);
      const data = response.data;
    
      if (data.status === "OK") {
        const { lat, lng } = data.results[0].geometry.location;
        return { lat, lon: lng };
      } else {
        throw new Error(`Geocoding failed: ${data.status}`);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.error_message || error.message);
    }
  }
);


export const updateUser = createAsyncThunk("users/updateUser", async (payload, { rejectWithValue }) => {
  try {
    const response = await api.post(`/serviceapi/updateUser`, payload);
    return response;
  } catch (error) {
    if (error.response && error.response.data.message) {
      return rejectWithValue(error.response.data.message);
    } else {
      return rejectWithValue(error.message);
    }
  }
});

export const deleteUser = createAsyncThunk("users/deleteUser", async (payload, { rejectWithValue }) => {
  try {
    const response = await api.post(`/serviceapi/deleteUser`, payload);
    return response;
  } catch (error) {
    if (error.response && error.response.data.message) {
      return rejectWithValue(error.response.data.message);
    } else {
      return rejectWithValue(error.message);
    }
  }
});
export const emailActiveAppUsers = createAsyncThunk("users/emailActiveAppUsers", async (payload, { rejectWithValue }) => {
  try {
    const response = await api.post(`/serviceapi/emailActiveAppUsers`, payload);
    return response;
  } catch (error) {
    if (error.response && error.response.data.message) {
      return rejectWithValue(error.response.data.message);
    } else {
      return rejectWithValue(error.message);
    }
  }
});
export const emailMileageToUser = createAsyncThunk(
  "users/emailMileageToUser",
  async (yearMonth, { rejectWithValue }) => {
    try {
      const response = await api.post(`/serviceapi/emailMonthlyMileage`, null, {
        params: { yearMonth }
      });

      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Something went wrong";
      return rejectWithValue(message);
    }
  }
);

